import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined'
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined'
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'
import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

const EXAMPLE_CATEGORIES = [
  {
    icon: <MedicalServicesOutlinedIcon />,
    title: 'Clinical',
    body: 'Medication issues, poor transfers of care, infection issues, medical device failures, delays in treatment, unexpected outcomes.',
  },
  {
    icon: <HealthAndSafetyOutlinedIcon />,
    title: 'Environment',
    body: 'Accidents, violence and aggression, staff ill health directly related to their work.',
  },
  {
    icon: <BadgeOutlinedIcon />,
    title: 'Professional',
    body: 'Records, breaches of confidentiality, standards, registration.',
  },
  {
    icon: <CloudOffOutlinedIcon />,
    title: 'Services',
    body: 'Loss of service, loss of data, performance issues, financial losses.',
  },
]

const ReportIncidentIntro = ({ setTab }) => (
  <Stack gap={2.5}>
    <Box>
      <Typography variant="h6" fontWeight={700}>
        What should I report?
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Report any event with the potential to produce unexpected or unwanted
        effects, or with a consequence or learning point — anything that causes
        a loss, injury or a near miss to a patient, staff or others.
      </Typography>
    </Box>

    <Box
      display="grid"
      gap={1.5}
      gridTemplateColumns={{ xs: '1fr', sm: '1fr 1fr', lg: 'repeat(4, 1fr)' }}
    >
      {EXAMPLE_CATEGORIES.map((category) => (
        <Card
          key={category.title}
          variant="outlined"
          sx={{ p: 1.5, borderRadius: 2.5 }}
        >
          <Stack gap={0.75}>
            <Box sx={{ color: 'primary.main' }}>{category.icon}</Box>
            <Typography fontWeight={700}>{category.title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {category.body}
            </Typography>
          </Stack>
        </Card>
      ))}
    </Box>

    <Alert severity="info" sx={{ borderRadius: 2 }}>
      Vehicle or equipment defects don't need an incident report unless the
      defect resulted in an incident — use the defect or VDI forms for those.
    </Alert>

    <Stack gap={1.5}>
      <Box>
        <Typography fontWeight={700}>What happens after I submit?</Typography>
        <Typography variant="body2" color="text.secondary">
          You'll be shown an incident reference number to confirm receipt —
          make a note of it. Your line manager is notified by email, along with
          the clinical and operations directors depending on the type of event.
          Further details can be added to the report later.
        </Typography>
      </Box>
      <Box>
        <Typography fontWeight={700}>How do I get feedback?</Typography>
        <Typography variant="body2" color="text.secondary">
          Your line manager, or the person investigating, should report back
          with the outcome of the investigation. You're welcome to request
          updates at any time.
        </Typography>
      </Box>
    </Stack>

    <Box display="flex" justifyContent="flex-end">
      <Button
        onClick={() => {
          setTab((prev) => prev + 1)
          window.scrollTo(0, 0)
        }}
        variant="contained"
        color="primary"
        endIcon={<ArrowForwardIcon />}
      >
        Start Report
      </Button>
    </Box>
  </Stack>
)

export default ReportIncidentIntro
